import { render, staticRenderFns } from "./DivideIcon.vue?vue&type=template&id=136f989a&scoped=true"
import script from "./DivideIcon.vue?vue&type=script&lang=js"
export * from "./DivideIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f989a",
  null
  
)

export default component.exports